<div class="w-100">
    <div class="page-info">
        <h3 style="margin: 25px; font-weight: 500; font-size:25px; color: #2a457a;">Tally Transactions</h3>
    </div>
    <div class="page-next"><mat-icon mat-list-icon style="padding: 1px;"
            routerLink="/daybook">arrow_circle_right</mat-icon>
    </div>
</div>

<div class="table-container" style="margin-left: 20px; margin-right: 20px;">
    <div class="w-100 border-p">
        <div class="mt-10 w-100" style="display: inline-flexbox;">
            <!-- From Date - To Date -->
            <mat-form-field class="w-20 pl-20 ml-5" appearance="outline">
                <mat-label class="custom-mat-label">From Date - To Date</mat-label>
                <mat-date-range-input [rangePicker]="picker">
                <input matStartDate matInput placeholder="Start date" [(ngModel)]="l_formData.fromDate"/>
                <input matEndDate matInput placeholder="End date" [(ngModel)]="l_formData.toDate"/>
                </mat-date-range-input>
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-date-range-picker #picker></mat-date-range-picker>
            </mat-form-field>
            <span style="margin-bottom: 10px; margin-top: 5px;">

                <!-- Verify Transactions -->
                <button mat-raised-button color="primary" class="custom-button-charcoal ml-5" (click)="lFN_VerifyTransactions();">
                    Verify Transactions
                </button>
                <!-- View Transactions -->
                <button mat-raised-button color="primary" class="custom-button-charcoal" (click)="lFN_ViewTallyTransactions();">
                    View Transactions
                </button>
                <!-- Export Reports -->
                <button mat-raised-button color="primary" class="custom-button-charcoal" (click)="lFN_Export();">
                    Export Reports
                </button>

                <span style="margin-left: 100px;"></span>

                <!-- Sync Transactions into Tally -->
                <!-- *ngIf="l_showSyncTxnButton" -->
                <button mat-raised-button color="primary" class="custom-button-blue" (click)="lFN_SyncTallyTransactions();">
                    Sync Online Transactions
                </button>
                <!-- Sync Accounts Receipts into Tally -->
                <!-- *ngIf="l_showSyncTxnButton" -->
                <button mat-raised-button color="primary" class="custom-button-blue" (click)="lFN_SyncAccountsReceipts();">
                    Sync Mandal Receipts
                </button>            
                <!-- Download Tally XML -->
                <button mat-raised-button color="primary" class="custom-button-blue" (click)="lFN_CheckUploadDownloadStatus();" *ngIf="l_showDownloadXMlButton">
                    Download Tally XML
                </button>

            </span>
        </div>
    </div>
</div>

<mat-tab-group #tallyTabsGroup>
    <mat-tab label="TRANSACTIONS ONLINE">
        <div class="mat-elevation-z8 table-container" style="margin-left: 20px; margin-right: 20px; margin-top: 30px;">
            <table mat-table [dataSource]="dataSourceJSYM" class="mat-table">
                <!-- TxnDate Column -->
                <ng-container matColumnDef="txnDate">
                    <th mat-header-cell *matHeaderCellDef>TxnDate</th>
                    <td mat-cell *matCellDef="let element">{{element.txnDate}}</td>
                </ng-container>
            
                <!-- Receipt Number Column -->
                <ng-container matColumnDef="receiptNumber">
                    <th mat-header-cell *matHeaderCellDef>Receipt Number</th>
                    <td mat-cell *matCellDef="let element">{{element.transaction.receiptIdPrefixed}}</td>
                </ng-container>
              
                <!-- Narration Column -->
                <ng-container matColumnDef="narration">
                    <th mat-header-cell *matHeaderCellDef>Narration</th>
                    <td mat-cell *matCellDef="let element">{{element.naration}}</td>
                </ng-container>
        
                <!-- Purpose Column -->
                <ng-container matColumnDef="purpose">
                    <th mat-header-cell *matHeaderCellDef>Purpose</th>
                    <td mat-cell *matCellDef="let element">{{element.purpose}}</td>
                </ng-container>
        
                <!-- Amount Column -->
                <ng-container matColumnDef="amount">
                    <th mat-header-cell *matHeaderCellDef>Amount</th>
                    <td mat-cell *matCellDef="let element">{{element.amount}}</td>
                </ng-container>
        
                <!-- Status Column -->
                <ng-container matColumnDef="status">
                    <th mat-header-cell *matHeaderCellDef>Status</th>
                    <td mat-cell *matCellDef="let element">{{element.status}}</td>
                </ng-container>
        
                <!-- Ledger Entries Column -->
                <ng-container matColumnDef="ledgerEntries">
                    <th mat-header-cell *matHeaderCellDef>Ledger Entries</th>
                    <td mat-cell *matCellDef="let element" class="actions-cell">
                        <button mat-icon-button (click)="lFN_ViewLedgerEntries(element);">
                            <mat-chip class="status-chip active-status">
                                <mat-label>View</mat-label>
                            </mat-chip>
                        </button>
                    </td>
                </ng-container>
          
          
              <tr mat-header-row *matHeaderRowDef="displayedColumnsJSYM"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumnsJSYM;"></tr>
            </table>
          
            <mat-paginator
              [pageSizeOptions]="[10, 20, 30]"
              showFirstLastButtons
              #paginatorJSYM
            ></mat-paginator>
        </div>
    </mat-tab>
    <mat-tab label="RECEIPTS MANDAL">
        <div class="mat-elevation-z8 table-container" style="margin-left: 20px; margin-right: 20px; margin-top: 30px;">
            <table mat-table [dataSource]="dataSourceTAAM" class="mat-table">
                <!-- TxnDate Column -->
                <ng-container matColumnDef="txnDate">
                    <th mat-header-cell *matHeaderCellDef>TxnDate</th>
                    <td mat-cell *matCellDef="let element">{{element.txnDate}}</td>
                </ng-container>
            
                <!-- Receipt Number Column -->
                <ng-container matColumnDef="receiptNumber">
                    <th mat-header-cell *matHeaderCellDef>Receipt Number</th>
                    <td mat-cell *matCellDef="let element">{{element.transaction.receiptIdPrefixed}}</td>
                </ng-container>
              
                <!-- Narration Column -->
                <ng-container matColumnDef="narration">
                    <th mat-header-cell *matHeaderCellDef>Narration</th>
                    <td mat-cell *matCellDef="let element">{{element.naration}}</td>
                </ng-container>
        
                <!-- Purpose Column -->
                <ng-container matColumnDef="purpose">
                    <th mat-header-cell *matHeaderCellDef>Purpose</th>
                    <td mat-cell *matCellDef="let element">{{element.purpose}}</td>
                </ng-container>
        
                <!-- Amount Column -->
                <ng-container matColumnDef="amount">
                    <th mat-header-cell *matHeaderCellDef>Amount</th>
                    <td mat-cell *matCellDef="let element">{{element.amount}}</td>
                </ng-container>
        
                <!-- Status Column -->
                <ng-container matColumnDef="status">
                    <th mat-header-cell *matHeaderCellDef>Status</th>
                    <td mat-cell *matCellDef="let element">{{element.status}}</td>
                </ng-container>
        
                <!-- Ledger Entries Column -->
                <ng-container matColumnDef="ledgerEntries">
                    <th mat-header-cell *matHeaderCellDef>Ledger Entries</th>
                    <td mat-cell *matCellDef="let element" class="actions-cell">
                        <button mat-icon-button (click)="lFN_ViewLedgerEntries(element);">
                            <mat-chip class="status-chip active-status">
                                <mat-label>View</mat-label>
                            </mat-chip>
                        </button>
                    </td>
                </ng-container>        
                        
          
                <!-- Actions -->
                <ng-container matColumnDef="actions">
                    <th mat-header-cell *matHeaderCellDef>Actions</th>
                    <td mat-cell *matCellDef="let element" class="actions-cell">
                        <button mat-icon-button (click)="lFN_DeleteTallyEntries(element, 'HOLD_OBJECT_DATA');">
                            <mat-icon title="Delete Tally Ledger Entries" style="-webkit-text-fill-color: #2a457a">delete_forever</mat-icon>
                        </button>
                    </td>
                </ng-container>
          
          
              <tr mat-header-row *matHeaderRowDef="displayedColumnsTAAM"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumnsTAAM;"></tr>
            </table>
          
            <mat-paginator
              [pageSizeOptions]="[10, 20, 30]"
              showFirstLastButtons
              #paginatorTAAM
            ></mat-paginator>
        </div>
    </mat-tab>
</mat-tab-group>

<!-- Delete Tally Ledger Entry Modal -->
<div class="modal" *ngIf="l_showDeleteTallyEntryModal">
    <div class="modal-content">
        <div class="header-title">
            Confirmation
            <span class="close" (click)="lFN_CloseModals();">&times;</span>
        </div>
        <div style="margin-top: 20px; margin-bottom: 20px;">
            <span class="modal-description">Do you really want to delete Tally Ledger Entry for selected records ?</span>
        </div>
        <div style="display: inline-flexbox; margin-top: 20px; margin-bottom: 10px; float: right;">
            <button mat-raised-button color="primary" class="custom-button-blue pl-20 pr-20"
            style="margin-top: 4px; margin-left: 5px;" (click)="lFN_DeleteTallyEntries(null, 'DELETE_OBJECT');">
            Proceed
        </button>
        <button mat-raised-button color="primary" class="custom-button-blue pl-20 pr-20"
            style="margin-top: 4px; margin-left: 5px;" (click)="lFN_CloseModals(); this.l_tallyObject = null;">
            Close
        </button>
        </div>
    </div>
</div>

<!-- Export Modal -->
<div class="modal" *ngIf="l_showExportModal">
    <div class="modal-content">
        <div class="header-title">
            Please select a report type for download
            <span class="close" (click)="lFN_CloseModals();">&times;</span>
        </div>
        <div style="display: inline-flexbox; margin-top: 20px; margin-bottom: 10px;">
            <button mat-raised-button color="primary" class="custom-button-blue pl-20 pr-20"
                style="margin-top: 4px; margin-left: 5px;" (click)="lFN_DownloadReport('ledgerwise');">
                Ledgerwise Report
            </button>
            <button mat-raised-button color="primary" class="custom-button-blue pl-20 pr-20"
                style="margin-top: 4px; margin-left: 5px;" (click)="lFN_DownloadReport('purposewise');">
                Purposewise Report
            </button>
            <button mat-raised-button color="primary" class="custom-button-blue pl-20 pr-20"
                style="margin-top: 4px; margin-left: 5px;" (click)="lFN_DownloadReport('detailedLedgerwise');">
                Detailed Report
            </button>
        </div>
    </div>
</div>

<!-- Ledger Entries Modal -->
<div class="modal" *ngIf="l_showLedgerEntryModal">
    <div class="modal-content">
        <div class="header-title" style="padding-left: 25px;">
            Tally Ledger Entries
            <span class="close" (click)="lFN_CloseModals();">&times;</span>
        </div>
        <div style="margin-top: 20px; padding-left: 20px; padding-right: 20px;">
            <table mat-table [dataSource]="dataSourceLedgerEntry" class="mat-table ledger-entry-table">
                <!-- Amount Column -->
                <ng-container matColumnDef="name">
                    <th mat-header-cell *matHeaderCellDef class="column-padding">Ledger Head</th>
                    <td mat-cell *matCellDef="let element" class="column-padding">{{element.ledgerHead.name}}</td>
                </ng-container>

                <!-- Amount Column -->
                <ng-container matColumnDef="entryType">
                    <th mat-header-cell *matHeaderCellDef class="column-padding">Entry Type</th>
                    <td mat-cell *matCellDef="let element" class="column-padding">{{((element.ledgerHead.entryType === 'C') ? 'Credit': 'Debit')}}</td>
                </ng-container>

                <!-- Amount Column -->
                <ng-container matColumnDef="amount">
                    <th mat-header-cell *matHeaderCellDef class="column-padding">Amount</th>
                    <td mat-cell *matCellDef="let element" class="column-padding">{{element.amount}}</td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumnsLedgerEntry"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumnsLedgerEntry;"></tr>
            </table>
        </div>
    </div>
</div>